<template>
	<v-list-item
		:active="isActive"
		rounded="lg"
		class="clip-list-item"
		@click="emit('click')">
		<template #prepend>
			<v-chip size="small" variant="flat" class="clip-badge mr-3">
				{{ index + 1 }}
			</v-chip>
		</template>

		<v-list-item-title class="text-body-2">
			{{ formatSeconds(clip.startTime) }} &mdash; {{ formatSeconds(clip.endTime) }}
		</v-list-item-title>
		<v-list-item-subtitle class="text-caption">
			Duration: {{ formatDurationShort(clip.endTime - clip.startTime) }}
		</v-list-item-subtitle>

		<template #append>
			<v-btn icon variant="plain" color="error" density="compact" @click.stop="emit('remove')">
				<v-icon>icon-trash-full-stroke</v-icon>
				<v-tooltip activator="parent" location="top">Remove clip</v-tooltip>
			</v-btn>
		</template>
	</v-list-item>
</template>

<script setup lang="ts">
	import type { VideoClip } from "@/types/clipVideo";
	import { formatSeconds, formatDurationShort } from "@/helpers/time";

	defineProps<{
		clip: VideoClip;
		index: number;
		isActive: boolean;
	}>();

	const emit = defineEmits<{
		(e: "remove"): void;
		(e: "click"): void;
	}>();
</script>

<style scoped>
	.clip-list-item {
		border: 1px solid rgba(var(--v-theme-on-surface), 0.08);
	}

	.clip-list-item:deep(.v-list-item__prepend) {
		align-self: center;
	}

	.clip-badge {
		background-color: rgba(var(--v-theme-on-surface), 0.05) !important;
		color: rgb(var(--v-theme-primary)) !important;
	}
</style>
